import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'slice', 'Slice', [["path",{"d":"M3 19l15 -15l3 3l-6 6l2 2a14 14 0 0 1 -14 4"}]]);